import { useCallback, useEffect, useState } from "react";

import { Button, Card,CardBody, Col,Spinner, Row } from "reactstrap";
import { TbDatabaseOff } from "react-icons/tb";

import CustomInput from "../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../Component/BasicComponents/Dropdowns/Dropdown";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useGetAgendaControlType } from "../Configuration/Agenda/UseAgenda";
import { useGetDarReport} from "./DarReportHook/useDarRepo";
import PaginatedRouteDropdown from "../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getDarReport, getEmpolyeeFilter } from "./DarReportHook/DarRepo";
import { getAllTerritory } from "../FSM/Beats_Patches/hooks/BeatRepository";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { COLORS } from "../../constants/colors";
import { showToast } from "../../utils/toastUtils";

type Props = {};

interface filterInterface {
  page?: number;
  limit?: number;
  employeeId?: number | undefined;
  territoryId?: number | undefined;
  createdDate?: string;
  agendaControlType?: string;
  employeeCode?: string;
  firstName?: string;
  outletName?: string;
  outletCode?: string;
  agendaName?: string;
  positionName?: string;
  townName?: string;
  dcrDate?: string;
  dcrStatus?: string;
  orgUnitName?: string;
  sgpiOut?: string;
  edDuration?: string;
  action: string;
}

function DARReport({}: Props) {
  const { startPolling } = useExcelPolling();
  const initalFilterData_Dar: filterInterface = {
    page: 1,
    limit: 10,
    employeeId: undefined,
    territoryId: undefined,
    createdDate: "",
    agendaControlType: "",
    employeeCode: "",
    firstName: "",
    outletName: "",
    outletCode: "",
    agendaName: "",
    positionName: "",
    townName: "",
    dcrDate: "",
    dcrStatus: "",
    orgUnitName: "",
    sgpiOut: "",
    edDuration: "",
    action: "view",
  };
  const [filter, setFilter] = useState(initalFilterData_Dar);
  const [result, setResult] = useState<boolean>(false);
  const [selectedEmpolyee, setSelectedEmpolyee] = useState<{
    id: number;
    label: string;
  } | null>(null);
  const [selectedTerritory, setSelectedTerritory] = useState<{
    id: number;
    label: string;
  } | null>(null);

  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const {
    data: AgendaControlType,
    isLoading: AgendaControlType_IsLoading,
    isSuccess: AgendaControlType_IsSuccess,
  } = useGetAgendaControlType({ enabled: true });
  const {
    data: DarReportData,
    isLoading: DarReportData_Isloading,
    isSuccess: DarReportData_isSuccess,
  } = useGetDarReport({
    param: {
      page: filter.page,
      limit: filter.limit,
      action: filter.action,
      ...(filter.employeeId === undefined
        ? {}
        : { employeeId: filter.employeeId || selectedEmpolyee?.id }),
      ...(filter.territoryId === undefined
        ? {}
        : { territoryId: filter.territoryId || selectedTerritory?.id }),
      ...(filter.createdDate === "" ? {} : { createdDate: filter.createdDate }),
      ...(filter.agendaControlType === ""
        ? {}
        : { agendaControlType: filter.agendaControlType }),
      ...(filter.employeeCode === ""
        ? {}
        : { employeeCode: filter.employeeCode }),
      ...(filter.firstName === "" ? {} : { firstName: filter.firstName }),
      ...(filter.outletName === "" ? {} : { outletName: filter.outletName }),
      ...(filter.outletCode === "" ? {} : { outletCode: filter.outletCode }),
      ...(filter.agendaName === "" ? {} : { agendaName: filter.agendaName }),
      ...(filter.positionName === ""
        ? {}
        : { positionName: filter.positionName }),
      ...(filter.townName === "" ? {} : { townName: filter.townName }),
      ...(filter.dcrDate === "" ? {} : { dcrDate: filter.dcrDate }),
      ...(filter.dcrStatus === "" ? {} : { dcrStatus: filter.dcrStatus }),
      ...(filter.orgUnitName === "" ? {} : { orgUnitName: filter.orgUnitName }),
      ...(filter.sgpiOut === "" ? {} : { sgpiOut: filter.sgpiOut }),
      ...(filter.edDuration === "" ? {} : { edDuration: filter.edDuration }),
    },
    enable: result,
  });

  const formatedData = Array.isArray(DarReportData?.rowData.data.DARReportData)
    ? DarReportData?.rowData.data.DARReportData.map((item: any) => ({
        DcrId: item.DcrId,
        Agendacontroltype: item.Agendacontroltype,
        EmployeeCode: item.EmployeeCode,
        FirstName: item.FirstName,
        OutletName: item.OutletName,
        OutletCode: item.OutletCode,
        Agendname: item.Agendname,
        PositionName: item.PositionName,
        Stownname: item.Stownname,
        DcrDate: item.DcrDate,
        DcrStatus: item.DcrStatus,
        Planned: item.Planned,
        UnitName: item.UnitName,
        Managers: item.Managers,
        BrandsDetailed: item.BrandsDetailed,
        SgpiOut: item.SgpiOut,
        PobTotal: item.PobTotal,
        EmployeeId: item.EmployeeId,
        EdDuration: item.EdDuration,
        TerritoryId: item.TerritoryId,
      }))
    : [];

  useEffect(() => {
    if (DarReportData && DarReportData.rowData) {
      setResult(false);
    }
  }, [DarReportData]);

  const handleResult = () => {
    //Loader till the data is not aviable  GPT work here
    setResult(true);
  };

  const handleReset = () => {
    // console.log('Reset');
    setResult(false);
    setSelectedEmpolyee(null);
    setSelectedTerritory(null);
    setFilter(initalFilterData_Dar);
  };

  const handleFiltre = useCallback((key: keyof filterInterface, value: any) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const buildQuery = (param: Record<string, any>) => {
    return Object.entries(param || {})
      .filter(
        ([key, value]) =>
          key !== "limit" &&
          key !== "page" &&
          key !== "action" &&
          value !== undefined &&
          value !== ""
      )
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
  };

  const handleDownload = async () => {
    const param = {
      page: filter.page,
      limit: filter.limit,
      action: "download",
      ...(filter.employeeId === undefined
        ? {}
        : { employeeId: filter.employeeId || selectedEmpolyee?.id }),
      ...(filter.territoryId === undefined
        ? {}
        : { territoryId: filter.territoryId || selectedTerritory?.id }),
      ...(filter.createdDate === "" ? {} : { createdDate: filter.createdDate }),
      ...(filter.agendaControlType === ""
        ? {}
        : { agendaControlType: filter.agendaControlType }),
      ...(filter.employeeCode === ""
        ? {}
        : { employeeCode: filter.employeeCode }),
      ...(filter.firstName === "" ? {} : { firstName: filter.firstName }),
      ...(filter.outletName === "" ? {} : { outletName: filter.outletName }),
      ...(filter.outletCode === "" ? {} : { outletCode: filter.outletCode }),
      ...(filter.agendaName === "" ? {} : { agendaName: filter.agendaName }),
      ...(filter.positionName === ""
        ? {}
        : { positionName: filter.positionName }),
      ...(filter.townName === "" ? {} : { townName: filter.townName }),
      ...(filter.dcrDate === "" ? {} : { dcrDate: filter.dcrDate }),
      ...(filter.dcrStatus === "" ? {} : { dcrStatus: filter.dcrStatus }),
      ...(filter.orgUnitName === "" ? {} : { orgUnitName: filter.orgUnitName }),
      ...(filter.sgpiOut === "" ? {} : { sgpiOut: filter.sgpiOut }),
      ...(filter.edDuration === "" ? {} : { edDuration: filter.edDuration }),
    };
    try {
      setLoadingExcel(true);
      // console.log('param::',param);
      const response = await getDarReport(param);
      // console.log("DAR report", response.rowData);
      const { success, fileDownloadId, intervalTime } = response.rowData.data || {};
      // console.log('success, fileDownloadId, intervalTime',success, fileDownloadId, intervalTime)
      // return;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url:string) => {
            setLoadingExcel(false);
            setExcelStatus('Loading..');
            const a = document.createElement('a');
            a.href = url;
            a.download = 'report.xlsx';
            a.click();
            showToast.success('The file is ready!');
          },
          onFaled:(message:string)=>showToast.error(message ||"onFalied error in DAR report excel"),
          onExpired:(message:string)=>showToast.error(message||"onExpired error in DAR report excel"),
          onDeleted:(message:string)=>showToast.error(message || "onDeleted error in DAR report excel ")
        });
      }
    } catch (error: any) {
      console.log("Error while downloading excel in DAR report");
    }
  };

  const handlePagination = (pagination: number) => {
    setFilter((prev: any) => ({
      ...prev,
      page: pagination,
    }));
  };

  const handleonChangeRowsPerPage = (newPerPage: number, page: number) => {
    setFilter((prev: any) => ({
      ...prev,
      page: page,
      limit: newPerPage,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="DAR Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  "..."
                : ""
              : "Excel",
            onClick: () => handleDownload(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />

      <Card>
        <CardBody>
          <Row>
            {/* <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Attendance Date*"
                placeholder=""
                type="date"
                // value={formValues?.rate}
                // onChange={handleInputChange}
              />
            </Col> */}
            <Col xl="2" lg="3">
              <ReusableDropdown
                options={
                  (!AgendaControlType_IsLoading &&
                    AgendaControlType_IsSuccess &&
                    AgendaControlType?.data) ||
                  []
                }
                onSelect={(value: any) => {
                  handleFiltre("agendaControlType", value.id);
                }}
                DropdownHeading="Agenda Control Type*"
                //   value={formValues?.products}
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Employee Code*"
                placeholder=""
                type="text"
                value={filter.employeeCode}
                onChange={(val: any) =>
                  handleFiltre("employeeCode", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="First Name"
                placeholder=""
                type="text"
                value={filter.firstName}
                onChange={(val: any) =>
                  handleFiltre("firstName", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Name of Outltet"
                placeholder=""
                type="text"
                value={filter.outletName}
                onChange={(val: any) =>
                  handleFiltre("outletName", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Outlet Code"
                placeholder=""
                type="text"
                value={filter.outletCode}
                onChange={(val: any) =>
                  handleFiltre("outletCode", val.target.value)
                }
              />
            </Col>
          </Row>
          {/* <div className="d-flex justify-content-start gap-2"> */}

          <Row>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Agenda Name"
                placeholder=""
                type="text"
                value={filter.agendaName}
                onChange={(val: any) =>
                  handleFiltre("agendaName", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Position Name"
                placeholder=""
                type="text"
                value={filter.positionName}
                onChange={(val: any) =>
                  handleFiltre("positionName", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Town Name"
                placeholder=""
                type="text"
                value={filter.townName}
                onChange={(val: any) =>
                  handleFiltre("townName", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="DCR Date"
                placeholder=""
                type="date"
                value={filter.dcrDate}
                onChange={(val: any) =>
                  handleFiltre("dcrDate", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="DCR Status"
                placeholder=""
                type="text"
                value={filter.dcrStatus}
                onChange={(val: any) =>
                  handleFiltre("dcrStatus", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Unit Name"
                placeholder=""
                type="text"
                value={filter.orgUnitName}
                onChange={(val: any) =>
                  handleFiltre("orgUnitName", val.target.value)
                }
              />
            </Col>
          </Row>

          <Row>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="SGPI Out"
                placeholder=""
                type="text"
                value={filter.sgpiOut}
                onChange={(val) => handleFiltre("sgpiOut", val.target.value)}
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="ED Duration"
                placeholder=""
                type="text"
                value={filter.edDuration}
                onChange={(val: any) =>
                  handleFiltre("edDuration", val.target.value)
                }
              />
            </Col>
            <Col xl="2" lg="3" style={{ zIndex: 9, marginTop: "-5px" }}>
              <PaginatedRouteDropdown
                key={selectedEmpolyee ? selectedEmpolyee.id : "employee-null"}
                DropdownHeading="Employee"
                initialSelectedOptions={selectedEmpolyee} // ✅ Only for showing selected
                onChange={(val: any) => {
                  setSelectedEmpolyee(val);
                }}
                fetchOptions={async (page: any, search: any) => {
                  const res = await getEmpolyeeFilter({
                    search: search || "",
                    page,
                    limit: 10,
                  });
                  return res.formatedData;
                }}
              />
            </Col>

            <Col xl="2" lg="3" style={{ zIndex: 9, marginTop: "-5px" }}>
              <PaginatedRouteDropdown
                key={
                  selectedTerritory ? selectedTerritory.id : "territory-null"
                }
                DropdownHeading="Territory"
                initialSelectedOptions={selectedTerritory} // ✅ Only for showing selected
                onChange={(val: any) => {
                  setSelectedTerritory(val);
                }}
                fetchOptions={async (page: any, search: any) => {
                  const res = await getAllTerritory({
                    search: search || "",
                    page,
                    limit: 10,
                  });
                  return res.formatedData;
                }}
              />
            </Col>
            <Col xl="2" lg="3">
              <CustomInput
                style={{ borderRadius: "4px" }}
                label="Employee ID"
                placeholder=""
                type="text"
                value={filter.employeeId}
                onChange={(val: any) =>
                  handleFiltre("employeeId", val.target.value)
                }
              />
            </Col>
            <Col xl="4" lg="3">
              <Button
                style={{ backgroundColor: "#2e8dd3", border: "none" }}
                className="btn"
                onClick={handleResult}
              >
                Result
              </Button>

              <Button
                style={{ backgroundColor: "#43B9B2", border: "none" }}
                className="btn ms-3"
                onClick={handleReset}
              >
                Reset
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div>
        {DarReportData_Isloading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spinner color="primary" />
            </div>{" "}
            {/* Replace with Spinner if you like */}
          </div>
        ) : DarReportData?.rowData.data.DARReportData.length > 0 ? (
          <BasicDataTable
            Title=""
            data={formatedData || []}
            columns={employeeReportsColumn}
            search={false}
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            paginationTotalRows={
              DarReportData?.rowData?.data?.Pagination?.TotalCounts || 0
            }
          />
        ) : (
          <div style={{ textAlign: "center", color: "red" }}>
            Data is not available{" "}
            <TbDatabaseOff size={20} style={{ color: "black" }} />
          </div>
        )}
      </div>
    </div>
  );
}

export default DARReport;
const employeeReportsColumn = [
  {
    name: "Dcr Id",
    selector: (row: { DcrId: string }) => (row.DcrId ? row.DcrId : "-"),
    sortable: true,
    // width: "180px",
  },
  {
    name: "Agenda Controltype",
    selector: (row: { Agendacontroltype: string }) =>
      row.Agendacontroltype ?? "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Employee Code",
    selector: (row: { EmployeeCode: string }) => row.EmployeeCode ?? "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "First Name",
    selector: (row: { FirstName: string }) => row.FirstName || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Outlet Name",
    selector: (row: { OutletName: string }) => row.OutletName || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Outlet Code",
    selector: (row: { OutletCode: string }) => row.OutletCode || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Agend Name",
    selector: (row: { Agendname: string }) => row.Agendname || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Position Name",
    selector: (row: { PositionName: string }) => row.PositionName || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Stown Name",
    selector: (row: { Stownname: string }) => row.Stownname || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "DcrDate",
    selector: (row: { DcrDate: string }) => row.DcrDate || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "DcrStatus",
    selector: (row: { DcrStatus: string }) => row.DcrStatus || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Planned",
    selector: (row: { Planned: string }) => row.Planned || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "UnitName",
    selector: (row: { UnitName: string }) => row.UnitName || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Managers",
    selector: (row: { Managers: string }) => row.Managers || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Brands Detailed",
    selector: (row: { BrandsDetailed: string }) => row.BrandsDetailed || "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "SgpiOut",
    selector: (row: { SgpiOut: string }) => row.SgpiOut || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Pob Total",
    selector: (row: { PobTotal: string }) => row.PobTotal || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Employee Id",
    selector: (row: { EmployeeId: string }) => row.EmployeeId || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "EdDuration",
    selector: (row: { EdDuration: string | number }) =>
      `${row.EdDuration === 0 ? "0" : row.EdDuration}` || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Territory Id",
    selector: (row: { TerritoryId: string }) => row.TerritoryId || "-",
    sortable: true,
    width: "150px",
  },
];
